import { PropsWithChildren } from 'preact/compat';
import Sheet from 'react-modal-sheet';
import './style.css';

type Props = {
  open: boolean;
  toggle: () => void;
  children: JSX.Element;
};

const ModalSheetMobile = ({
  open,
  toggle,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Sheet
      isOpen={open}
      onClose={toggle}
      tweenConfig={{ ease: 'easeIn', duration: 0.3 }}
    >
      <Sheet.Container>
        <Sheet.Header>
          <div className="react-modal-sheet-grabber__wrapper">
            <div className="react-modal-sheet-grabber" />
            <div className="react-modal-sheet-grabber__gradient"></div>
          </div>
        </Sheet.Header>
        <Sheet.Content dragListener={false}>{children}</Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop onTap={toggle} />
    </Sheet>
  );
};

export default ModalSheetMobile;
